<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-portal />

		<VMain>
			<v-container>
				<v-row class="contentRow">
					<v-col>
						<h1>Unauthorized</h1>
						<p>We're sorry, but you don't have access to this page.</p>
						<v-btn outlined color="secondary" to="/">Back To Home</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</VMain>
		<test-error />
	</v-app>
</template>

<script>
export default {
	name: "NotFound",
}
</script>
